import { ApiStatuses } from '../../../../../global/models/api-model';
import { OneTimePayment, ScheduledPayment } from '../../compensation/compensation-history/compensation-history-model';
import { Employment } from '../../employment/employment-model';
import { NewHireStep } from '../../new-hire/models/new-hire-model';
import { PensionEnrollmentInfo } from '../../pension-enrollment/models/pension-enrollment-model';
import { NewHireCoverageState, Tiers } from '../enrollment/models/coverage-models';
import { AdminGhlPendingEnrollment, MemberGhlEnrollment, MemberNewHireEnrollmentCoverage, MyCpgMidYearEnrollment } from '../member/models/member-coverage-model';
import { BenefitEnrollmentStep } from './pension-enrollment-models';
import { WhoWillEnrollCriterias } from './who-will-enroll-models';

export const memberScheduleHoursHighThreshold = 1000;

export enum NewHireEnrollmentStep {
	EMPLOYEE_RECORD = 'EMPLOYEE_RECORD',
	WHO_WILL_ENROLL = 'WHO_WILL_ENROLL',
	BENEFIT_ENROLLMENT = 'BENEFIT_ENROLLMENT',
}
export interface MemberOrAdmin {
	admin: boolean;
	member: boolean;
}
export interface EnrollmentOptions {
	benefit_options: {
		pension: MemberOrAdmin;
		medical: MemberOrAdmin;
		dental: MemberOrAdmin;
		disability: MemberOrAdmin;
		std: MemberOrAdmin;
		ltd: MemberOrAdmin;
	};
	require_approval?: boolean;
}

export interface CalculatedTiers {
	display_tier: keyof Tiers,
	selected_tier: keyof Tiers,
}

export interface MemberCompensation {
	compensations: ScheduledPayment[],
	otp: OneTimePayment[],
}

export interface CalculateVolumeRate {
	volume: number,
	rate: number,
}

export interface NewHireEnrollmentAppState {
	currentStep: NewHireEnrollmentStep,
	currentEnrollmentStep: BenefitEnrollmentStep;
	currentEmployeeReviewStep: NewHireStep;
	isEligible: boolean,
	enrollmentOptions: EnrollmentOptions,
	newHireCoverageState: NewHireCoverageState,
	newHireCoverageLoaded: boolean,
	tierToDisplayMedical: CalculatedTiers,
	tierToDisplayDental: CalculatedTiers,
	memberEmployment: Employment,
	memberEmploymentLoaded: boolean,
	memberCompensation: MemberCompensation,
	memberCompensationLoaded: boolean,
	memberCurrentEmploymentId: number;
	memberCurrentEmployer: {
		name: string,
		client_number: string,
	};
	memberCurrentEmploymentIdLoaded: boolean;
	memberPensionInfo: PensionEnrollmentInfo;
	memberPensionInfoLoaded: boolean;
	whoWillEnrollCriteria: WhoWillEnrollCriterias;
	memberCoverageState: MemberNewHireEnrollmentCoverage;
	memberGhlEnrollments: MemberGhlEnrollment[];
	calculatedVolumeRateValues: CalculateVolumeRate[];
	adminGhlpendingEnrollments: AdminGhlPendingEnrollment[];
	dioApproverCurrentFormId: number;
	myCpgOpenEnrollment?: MyCpgMidYearEnrollment[];
	myCpgPendingForApprovalEnrollment?: MyCpgMidYearEnrollment[];
	isLifeEventCoverageForm: boolean;
	apiError?: ApiStatuses;
	apiErrorMessage?: string;
}

export enum NewHireEnrollmentAppActions {
	SET_NEW_HIRE_ENROLLMENT_CURRENT_STEP = 'SET_NEW_HIRE_ENROLLMENT_CURRENT_STEP',
	SET_NEW_HIRE_ENROLLMENT_ELIGIBILITY = 'SET_NEW_HIRE_ENROLLMENT_ELIGIBILITY',
	SET_NEW_HIRE_ENROLLMENT_OPTIONS = 'SET_NEW_HIRE_ENROLLMENT_OPTIONS',
	CLEAR_NEW_HIRE_ENROLLMENT_OPTIONS = 'CLEAR_NEW_HIRE_ENROLLMENT_OPTIONS',
	SET_NEW_HIRE_ENROLLMENT_COVERAGE = 'SET_NEW_HIRE_ENROLLMENT_COVERAGE',
	CLEAR_NEW_HIRE_ENROLLMENT_COVERAGE = 'CLEAR_NEW_HIRE_ENROLLMENT_COVERAGE',
	SET_NEW_HIRE_TIER = 'SET_NEW_HIRE_TIER',
	SET_NEW_HIRE_BENEFIT_ENROLLMENT_CURRENT_STEP = 'SET_NEW_HIRE_BENEFIT_ENROLLMENT_CURRENT_STEP',
	SET_NEW_HIRE_EMPLOYEE_REVIEW_CURRENT_STEP = 'SET_NEW_HIRE_EMPLOYEE_REVIEW_CURRENT_STEP',
	CLEAR_NEW_HIRE_ENROLLMENT_STATE = 'CLEAR_NEW_HIRE_ENROLLMENT_STATE',
	SET_NEW_HIRE_MEMBER_EMPLOYMENT = 'SET_NEW_HIRE_MEMBER_EMPLOYMENT',
	CLEAR_NEW_HIRE_MEMBER_EMPLOYMENT = 'CLEAR_NEW_HIRE_MEMBER_EMPLOYMENT',
	SET_NEW_HIRE_MEMBER_COMPENSATION = 'SET_NEW_HIRE_MEMBER_COMPENSATION',
	CLEAR_NEW_HIRE_MEMBER_COMPENSATION = 'CLEAR_NEW_HIRE_MEMBER_COMPENSATION',
	SET_NEW_HIRE_MEMBER_EMPLOYMENT_DATA = 'SET_NEW_HIRE_MEMBER_EMPLOYMENT_DATA',
	CLEAR_NEW_HIRE_MEMBER_EMPLOYMENT_DATA = 'CLEAR_NEW_HIRE_MEMBER_EMPLOYMENT_DATA',
	SET_NEW_HIRE_MEMBER_PENSION_INFO = 'SET_NEW_HIRE_MEMBER_PENSION_INFO',
	CLEAR_NEW_HIRE_MEMBER_PENSION_INFO = 'CLEAR_NEW_HIRE_MEMBER_PENSION_INFO',
	SET_WHO_WILL_ENROLL_CRITERIA = 'SET_WHO_WILL_ENROLL_CRITERIA',
	SET_MEMBER_NEW_HIRE_COVERAGE = 'SET_MEMBER_NEW_HIRE_COVERAGE',
	CLEAR_MEMBER_NEW_HIRE_COVERAGE = 'CLEAR_MEMBER_NEW_HIRE_COVERAGE',
	SET_MEMBER_GHL_ENROLLMENTS = 'SET_MEMBER_GHL_ENROLLMENTS',
	SET_RATE_USING_VOLUME = 'SET_RATE_USING_VOLUME',
	SET_ADMIN_GHL_PENDING_ENROLLMENTS = 'SET_ADMIN_GHL_PENDING_ENROLLMENTS',
	SET_DIO_APPROVER_CURRENT_FORM_ID = 'SET_DIO_APPROVER_CURRENT_FORM_ID',
	SET_MYCPG_MIDYEAR_OPEN_ENROLLMENT = 'SET_MYCPG_MIDYEAR_OPEN_ENROLLMENT',
	SET_MYCPG_MIDYEAR_PENDING_APPROVAL_ENROLLMENT = 'SET_MYCPG_MIDYEAR_PENDING_APPROVAL_ENROLLMENT',
	SET_IS_LIFE_EVENT_COVERAGE_FORM = 'SET_IS_LIFE_EVENT_COVERAGE_FORM',
	SET_COVERAGE_FORM_ERROR = 'SET_COVERAGE_FORM_ERROR',
}